import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-snippet',
  templateUrl: './snippet.component.html',
  styleUrls: ['./snippet.component.sass']
})
export class SnippetComponent implements OnInit {
  @Input() code: string;

  constructor(
  ) {}

  ngOnInit() {}

  syntax(string) {
    try {
      string = string.replace(/[”"”]/g, '"')
      string = JSON.parse(string)
      string = JSON.stringify(string, null, 2)

      string = string.replace(/("(.*?)"):/g, '{key}$1{/key}: ')
      string = string.replace(/:\s+("(.*?)")/g, ': {value}$1{/value}')
      string = string.replace(/:\s+(\d+)/g, ': {value}$1{/value}')

      string = string.replace(/\{key\}/g, '<span class="key">')
      string = string.replace(/\{\/key}/g, '</span>')
      string = string.replace(/\{value\}/g, '<span class="value">')
      string = string.replace(/\{\/value}/g, '</span>')
    } catch(e) {

    }

    return string
  }
}
